import deleteCategoryRow from '../actions/deleteCategoryRow';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import {
    isCategoryInFavorites,
    ToggleFavoriteButton,
    lazyAddFavoriteCategory,
    lazyRemoveFavoriteCategory,
} from 'owa-favorites';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./CategoryRow.scss');

export interface CategoryIconBarProps {
    id: string;
    name: string;
    isNewCategoryPending: boolean;
}

@observer
export default class CategoryIconBar extends React.Component<CategoryIconBarProps, {}> {
    @computed
    get isCategoryInFavorites(): boolean {
        return isCategoryInFavorites(this.props.id);
    }

    render() {
        return <div className={styles.iconBar}>{this.renderActionIcons()}</div>;
    }

    private renderActionIcons(): JSX.Element[] {
        return [
            <IconButton
                key="delete"
                className={styles.categoryActionIcon}
                iconProps={{ iconName: ControlIcons.Delete }}
                onClick={() => deleteCategoryRow(this.props.id, this.props.name)}
                ariaLabel={strings.options_connected_full_deleteButton}
            />,
            <ToggleFavoriteButton
                key="favorites"
                isClickDisabled={this.props.isNewCategoryPending}
                isInFavorites={this.isCategoryInFavorites}
                iconStyles={styles.categoryActionIcon}
                onClick={this.onFavoriteClicked}
                animate={true}
                spinnerStyles={styles.spinnerContainer}
            />,
        ];
    }

    private onFavoriteClicked = async () => {
        // Toggle the favorite status
        if (isCategoryInFavorites(this.props.id)) {
            // Remove a category if it's already a favorited category
            const removeFavoriteCategory = await lazyRemoveFavoriteCategory.import();
            removeFavoriteCategory(this.props.id, 'CategoriesOptions');
        } else {
            // Add a category if the category that is clicked on not a favorite category
            const addFavoriteCategory = await lazyAddFavoriteCategory.import();
            addFavoriteCategory(this.props.id, 'CategoriesOptions');
        }
    };
}
